module["exports"] = [
  "Livros",
  "Filmes",
  "Música",
  "Jogos",
  "Eletrônicos",
  "Computadores",
  "Casa",
  "Jardim",
  "Ferramentas",
  "Mercearia",
  "Saúde",
  "Beleza",
  "Brinquedos",
  "Crianças",
  "Bebê",
  "Roupas",
  "Sapatos",
  "Jóias",
  "Esportes",
  "Turismo",
  "Automotivo",
  "Industrial"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_BR/commerce/department.js
// module id = 3394
// module chunks = 1609